import { render, staticRenderFns } from "./dev-tools.vue?vue&type=template&id=0b2e3fa7&scoped=true&"
import script from "./dev-tools.vue?vue&type=script&lang=js&"
export * from "./dev-tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e3fa7",
  null
  
)

export default component.exports